// Utility functions for profile update events

export const dispatchProfileUpdate = (updatedUserData = null) => {
  const event = new CustomEvent('profileUpdated', { 
    detail: { updatedUserData } 
  });
  window.dispatchEvent(event);
};

export const listenToProfileUpdates = (callback) => {
  const handleEvent = (event) => {
    callback(event.detail?.updatedUserData);
  };
  window.addEventListener('profileUpdated', handleEvent);
  return () => window.removeEventListener('profileUpdated', handleEvent);
};

// For when profile is updated from any component
export const refreshProfileInHeader = (updatedUserData = null) => {
  dispatchProfileUpdate(updatedUserData);
};